import React from 'react';
import '../QueuePage.scss'
import Skeleton from '../../../components/library/loaders/Skeleton';

const QueueTableLoader = () => (
    <div className="columns light-grey">
        <div className='column is-10 is-offset-1'>
            <Skeleton />
        </div>
    </div>
);

export default QueueTableLoader